<template>
    <div>
        <rkm-form
            v-if="!readonly"
            ref="Form"
        >
            <rkm-row class="flex-nowrap">
                <rkm-col class="flex-grow-1">
                    <rkm-form-input-autocomplete
                        :searchFields="localForm.autocompleteFields.convenioMedico"
                        :repository="repositories.convenioMedico"
                        v-model="convenioMedico"
                        :validations="validations.convenioMedico"
                        label="Convênio médico"
                        uppercase
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-button
                                @click="$refs.ModalConvenioMedico.open()"
                                color="primary"
                                title="Cadastrar convênio médico"
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col class="flex-grow-0">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click.stop="$refs.Form.validate(add)"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="conveniosMedicos"
            ref="Table"
            hide-filters
        >
            <template v-slot:cell(actions)="{ index }">
                <rkm-button
                    color="danger"
                    title="Excluir"
                    small
                    @click.stop="handleDestroy(index)"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <modal-convenio-medico
            ref="ModalConvenioMedico"
            @save="convenioMedico = $event"
        />
    </div>
</template>

<script>
// Components.
import ModalConvenioMedico from '@/components/cadastro/convenio-medico/Modal'

// Mixins.
import { repository, mask, object } from '@/mixins'

export default {
    components: { ModalConvenioMedico },
    mixins: [ repository, mask, object ],
    props: {
        readonly: { type: Boolean, default: false },
        conveniosMedicos: { type: Array, required: true },
    },
    data: () => ({
        repositories: {
            convenioMedico: null,
        },
        convenioMedico: null,
        localForm: {
            autocompleteFields: {
                convenioMedico: [
                    { key: 'nome', searchable: true },
                ],
            },
        }
    }),
    computed: {
        validations() {

            return {
                convenioMedico: { required: true }
            }
        },
        fields() {

            const fields = [
                { key: 'nome', label: 'Nome do convênio', sortable: true },
            ]

            if (!this.readonly) {

                fields.push({ key: 'actions', label: 'Ações', class: 'col-min' })
            }

            return fields
        }
    },
    methods: {
        async validate() {

            return true
        },
        add() {

            this.validateDuplicity()
                .then(valid => {

                    if (!valid) return

                    const convenioMedico = this.clone(this.convenioMedico)

                    this.conveniosMedicos.push(convenioMedico)

                    this.resetForm()
                })
        },
        async validateDuplicity() {

            const hasConvenioMedico = this.conveniosMedicos
                .find(cm => cm.id === this.convenioMedico.id)

            if (hasConvenioMedico) {

                this.showValidationNotification('O convênio médico já foi incluído.')

                return false
            }

            return true
        },
        resetForm() {

            this.convenioMedico = null

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleDestroy(index) {

            const destroy = async () => this.conveniosMedicos.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o convênio médico?', destroy)
        },
    },
    created() {

        this.repositories.convenioMedico = this.getConectaSusRepository('cadastro.sujeitoAtencao.convenioMedico')
    }
}
</script>